import { forwardRef } from 'react';

import { TProps } from '../types/TProps';

export const IconButtonClean = forwardRef<HTMLButtonElement, TProps>(
  ({ className, type = 'button', ...props }, ref) => (
    <button ref={ref} type={type} className={['icon-btn-clean', className].filter(Boolean).join(' ')} {...props} />
  ),
);

IconButtonClean.displayName = 'IconButtonClean';
